import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ef9096"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "heading" }, "Islamic Will Generator", -1))

import { ref } from "vue";
import Self from "@/bll/models/Self.mjs";
import FamilyTreeComponent from "./home_view/FamilyTreeComponent.vue";
import ShowTestsComponent from "./home_view/ShowTestsComponent.vue";
import { calculateInheritance } from "@/bll/calculator.mjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

var self: Self | undefined;
var key = 0;

var showTestsComponent = ref(false);

function handleButtonClick() {
  showTestsComponent.value = true;
}

function onTestSelectedCallback(selectedTest: Self) {
  calculateInheritance(10000);
  closeDialog();
  self = selectedTest;
  key++;
}

function closeDialog() {
  showTestsComponent.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("button", {
      id: "show-examples-dialog",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleButtonClick()))
    }, " Examples "),
    (_openBlock(), _createBlock(FamilyTreeComponent, {
      self: _unref(self),
      key: _unref(key)
    }, null, 8, ["self"])),
    (_unref(showTestsComponent))
      ? (_openBlock(), _createBlock(ShowTestsComponent, {
          key: 0,
          "on-test-click-callback": onTestSelectedCallback,
          "close-dialog": closeDialog
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})